var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 91,
    fill: "#000000",
    d: "M115.5 208C115.5 264.1 159 294.7 195.6 294.7C207.9 294.7 217.2 289.6 217.2 289.6L143.1 376L201 376L266.1 298.6C290.7 269.5 301.5 247.6 301.5 208C301.5 160.6 260.1 124 205.8 124C160.2 124 115.5 151.6 115.5 208ZM162 208.3C162 182.2 181.5 163 207.9 163C234.3 163 253.2 182.2 253.2 208.3C253.2 234.4 232.8 254.5 207.9 254.5C182.4 254.5 162 235 162 208.3ZM302.1 128.5L302.1 174.7L337.8 174.7L337.8 376L384.6 376L384.6 128.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b6897a6cc40f39ff11864e53934bfc8.svg";
export { ForwardRef as ReactComponent };